{
  "mar": {
    "title": "給藥紀錄",
    "loading": "載入給藥紀錄中...",
    "emptyState": "此病人沒有使用中的藥物醫囑",
    "loadError": "載入藥物失敗",
    "retry": "重試",
    "previousDay": "前一日",
    "nextDay": "後一日",
    "view24h": "24h",
    "view12h": "12h",
    "viewShift": "更次",
    "dayShiftHeader": "日更（07:00 - 19:00）",
    "nightShiftHeader": "夜更（19:00 - 07:00）",
    "newOrder": "新增藥物醫囑",
    "printMar": "列印給藥紀錄",
    "prnSection": "需要時（PRN）藥物",
    "filter": {
      "timeWindow": "時段",
      "category": "類別",
      "status": "狀態",
      "scheduledOnly": "只顯示已排期"
    },
    "adminStatus": {
      "scheduled": "已排期",
      "dueNow": "時間到",
      "overdue": "逾時",
      "administered": "已給藥",
      "held": "暫停",
      "refused": "拒絕",
      "missed": "遺漏"
    },
    "columns": {
      "medication": "藥物",
      "drug": "藥物",
      "doseRoute": "劑量 / 途徑",
      "schedule": "排期",
      "scheduledTime": "預定時間",
      "givenTime": "給藥時間",
      "givenBy": "給藥人員",
      "status": "狀態"
    },
    "actions": {
      "administer": "給藥",
      "hold": "暫停",
      "refuse": "拒絕",
      "skip": "略過",
      "missed": "標記為遺漏",
      "edit": "編輯給藥紀錄",
      "viewHistory": "查看紀錄",
      "givePrn": "PRN 給藥"
    },
    "prn": {
      "badge": "PRN",
      "highAlertBadge": "高警示藥物",
      "indication": "適應症：{{indication}}",
      "lastGiven": "上次給藥：{{time}}",
      "lastGivenBy": "上次給藥：{{time}}（{{user}}）"
    },
    "orderBadge": {
      "active": "使用中",
      "onHold": "暫停中",
      "discontinued": "已停用"
    },
    "legend": "圖例：",
    "summary": {
      "medsGivenToday": "今日已給藥：",
      "ofTotal": "{{given}} / {{total}}",
      "overdueCount_one": "逾時 {{count}} 項",
      "overdueCount_other": "逾時 {{count}} 項",
      "nextDue": "下次給藥：",
      "nextDueAt": "{{medName}}，{{time}}"
    },
    "tooltip": {
      "given": "（已給藥 {{time}}）",
      "pending": "正在記錄… 伺服器尚未確認"
    },
    "doseModal": {
      "title": "給藥",
      "doseGiven": "實際給藥劑量",
      "siteOfAdministration": "給藥部位",
      "comments": "備註",
      "vitalsCheck": "給藥前生命表徵核對",
      "doubleCheck": "雙人核對",
      "verifier": "核對人員",
      "confirm": "確認給藥"
    },
    "administerDialog": {
      "doseLabel": "劑量",
      "routeLabel": "途徑",
      "siteLabel": "給藥部位（如適用）",
      "site": {
        "notApplicable": "不適用",
        "leftArm": "左臂",
        "rightArm": "右臂",
        "leftDeltoid": "左三角肌",
        "rightDeltoid": "右三角肌",
        "leftGluteal": "左臀",
        "rightGluteal": "右臀",
        "leftThigh": "左大腿",
        "rightThigh": "右大腿",
        "abdomen": "腹部"
      },
      "timeAdministered": "給藥時間",
      "administeredDateAria": "給藥日期",
      "administeredTimeAria": "給藥時刻",
      "notesLabel": "備註",
      "notesPlaceholder": "選填備註..."
    },
    "prnWarning": {
      "title": "PRN 間隔時間警示",
      "lastDoseHoursAgo": "上次給藥距今 {{hours}} 小時。",
      "minimumInterval": "最短間隔為 {{hours}} 小時。",
      "lastAdministered": "上次給藥：{{time}}",
      "justificationLabel": "提前給藥之臨床理由",
      "justificationRequired": "*",
      "justificationPlaceholder": "請填寫早於最短間隔給藥的臨床理由...",
      "cancel": "取消",
      "overrideContinue": "覆寫並繼續"
    },
    "toast": {
      "administered": "已記錄給藥",
      "administerError": "記錄給藥失敗",
      "administerNotImplemented": "MAR 給藥記錄尚未啟用",
      "held": "已暫停給藥",
      "refused": "已記錄病人拒絕",
      "skipped": "已略過此次給藥",
      "orderNotActive": "此醫囑已不再有效（已停用、取消或完成），無法執行給藥。"
    },
    "holdRefuseDialog": {
      "holdTitle": "暫停給藥",
      "refuseTitle": "拒絕給藥",
      "skipTitle": "略過給藥",
      "scheduledLabel": "預定：{{time}}",
      "holdReasonLabel": "暫停原因",
      "refusalNotesLabel": "拒絕紀錄",
      "skipReasonLabel": "略過原因",
      "holdReasonPlaceholder": "請填寫暫停原因...",
      "refusalPlaceholder": "記錄病人拒絕情況...",
      "skipPlaceholder": "請填寫略過原因...",
      "cancel": "取消",
      "confirm": "確認"
    },
    "contextMenu": {
      "hold": "暫停",
      "refuse": "拒絕",
      "skip": "略過"
    },
    "holdReason": {
      "label": "暫停原因",
      "options": {
        "patientNpo": "病人 NPO（禁食）",
        "vitalsOutOfRange": "生命表徵超出範圍",
        "patientRefused": "病人拒絕",
        "providerOrder": "醫生指示暫停",
        "other": "其他"
      }
    },
    "give": {
      "title": "給藥 · {{medication}} {{dose}}",
      "scheduledLabel": "預定 {{time}}",
      "patientLabel": "病人",
      "patientLine": "{{name}} · {{mrn}}",
      "patientLineIdOnly": "病人ID：{{id}}",
      "medicationLabel": "藥物",
      "scanPatientPlaceholder": "掃描手帶",
      "scanPatientAria": "掃描病人手帶",
      "scanMedicationPlaceholder": "掃描藥物包裝條碼",
      "scanMedicationAria": "掃描藥物包裝",
      "patientMismatch": "此手帶不屬於該病人。請勿給藥。",
      "medicationMismatch": "此包裝並非醫囑藥物。請勿給藥。",
      "notScannable": "無法掃描核對 — 此醫囑未登記條碼",
      "overrideReason": "未掃描即給藥的理由",
      "overrideReasonPlaceholder": "例如：手帶損毀；無條碼的配製劑量",
      "pharmacyOverride": "藥劑部尚未核實此高警示藥物",
      "pharmacyOverridePlaceholder": "此次給藥為何不能等待藥劑部覆核？",
      "timeLabel": "時間",
      "detailsEdit": "編輯",
      "detailsDone": "完成",
      "confirmLabel": "以上資料與醫囑及手上藥物一致",
      "cancel": "取消",
      "submit": "給藥",
      "witness": {
        "banner": "高警示藥物 — 需第二位護士覆核",
        "usernameLabel": "第二位護士用戶名稱",
        "passwordLabel": "密碼",
        "verify": "覆核",
        "verifying": "覆核中…",
        "verified": "已由第二位護士覆核",
        "rejected": "無法辨識該登入資料。",
        "overrideLabel": "無法覆核？未經第二位護士覆核即給藥 — 理由",
        "overridePlaceholder": "此次給藥為何不能等待獨立雙人覆核？"
      },
      "refusal": {
        "wrongPatient": "病人不符 — 掃描的手帶與此醫囑不相符。請勿給藥。",
        "wrongMedication": "藥物不符 — 掃描的包裝與醫囑藥物不相符。請勿給藥。",
        "scanRequired": "請掃描手帶及藥物，或填寫未掃描的理由。",
        "pharmacyVerificationRequired": "藥劑部尚未核實此醫囑。請等待核實，或記錄無法等待的理由。",
        "doubleCheckRequired": "尚未有第二位護士對此醫囑進行雙人覆核。請安排覆核，或記錄無法等待的理由。",
        "doubleCheckSelf": "不可由本人覆核自己的給藥。須由第二位護士覆核。"
      },
      "dispense": {
        "handedOver": "{{quantity}} 已於 {{time}} 交付",
        "label": "藥房發藥",
        "none": "此醫囑暫無發藥記錄",
        "pending": "已記錄發藥，尚未交付",
        "prepared": "{{quantity}} 已於 {{time}} 配置",
        "unavailable": "無法查詢發藥情況——未能讀取記錄"
      }
    }
  },
  "status": {
    "active": "使用中",
    "held": "暫停",
    "discontinued": "停用",
    "completed": "已完成",
    "refused": "拒絕",
    "missed": "遺漏",
    "given": "已給藥"
  },
  "route": {
    "po": "口服",
    "iv": "靜脈注射",
    "im": "肌肉注射",
    "sc": "皮下注射",
    "in": "鼻腔",
    "pr": "肛門",
    "sl": "舌下",
    "top": "外用",
    "neb": "霧化吸入",
    "pv": "陰道",
    "ng": "鼻胃管",
    "ophthalmic": "眼用",
    "transdermal": "透皮"
  },
  "frequency": {
    "bid": "每日兩次",
    "tid": "每日三次",
    "qid": "每日四次",
    "qd": "每日一次",
    "qhs": "睡前",
    "prn": "需要時（PRN）",
    "stat": "立即（STAT）",
    "continuous": "持續給藥"
  },
  "formulary": {
    "title": "藥物處方集",
    "searchPlaceholder": "按藥物名稱、通用名或代碼搜尋...",
    "clearSearch": "清除搜尋",
    "category": {
      "all": "全部",
      "analgesic": "止痛類",
      "antibiotic": "抗生素",
      "antifungal": "抗真菌藥",
      "antiviral": "抗病毒藥",
      "cardiac": "心血管類",
      "endocrine": "內分泌類",
      "gi": "消化道類",
      "neurological": "神經系統類",
      "psychiatric": "精神科類",
      "respiratory": "呼吸系統類",
      "other": "其他"
    },
    "columns": {
      "medication": "藥物",
      "genericName": "通用名",
      "form": "劑型",
      "strength": "規格",
      "route": "給藥途徑",
      "status": "狀態",
      "schedule": "管制級別"
    },
    "highAlertBadge": "高警訊藥品",
    "highAlertTag": "高警訊",
    "status": {
      "preferred": "首選",
      "restricted": "限制使用",
      "nonFormulary": "非處方集"
    },
    "loading": "正在載入處方集...",
    "loadError": "無法載入處方集",
    "empty": "未找到藥物。",
    "pagination": {
      "showing": "顯示 {{from}}-{{to}}（共 {{total}} 項）",
      "page": "第 {{page}} 頁，共 {{totalPages}} 頁",
      "previous": "上一頁",
      "next": "下一頁"
    },
    "details": {
      "close": "關閉詳情",
      "genericName": "通用名",
      "category": "類別",
      "formStrength": "劑型 / 規格",
      "route": "給藥途徑",
      "formularyStatus": "處方集狀態",
      "deaSchedule": "DEA 管制級別",
      "indications": "適應症",
      "contraindications": "禁忌症",
      "interactions": "藥物相互作用",
      "sideEffects": "副作用",
      "dosageGuidelines": "用藥指引",
      "specialPopulations": "特殊人群",
      "storage": "貯存"
    }
  },
  "worklist": {
    "title": "Medication Worklist",
    "subtitle": "Active medications for the patients in your care",
    "summary": "{{medications}} medications across {{patients}} patients",
    "refresh": "Refresh",
    "searchPlaceholder": "Search by patient name, MRN, or medication...",
    "openMar": "Open MAR",
    "loadError": "Failed to load the medication worklist",
    "retry": "Retry",
    "priority": {
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "Routine",
      "scheduled": "Scheduled"
    },
    "empty": {
      "title": "Nothing to administer",
      "description": "No active medications for your patients."
    },
    "columns": {
      "medication": "Medication",
      "dose": "Dose",
      "route": "Route",
      "frequency": "Frequency",
      "priority": "Priority"
    },
    "row": {
      "mrnLabel": "MRN: {{mrn}}",
      "mrnUnknown": "---",
      "unknownPatient": "Unknown patient",
      "medCount_one": "{{count}} active medication",
      "medCount_other": "{{count}} active medications",
      "controlled": "Controlled {{schedule}}"
    }
  },
  "pharmacist": {
    "title": "藥劑師核對隊列",
    "subtitle": "審核並核對待處理的醫囑",
    "pendingCount": "待核對 {{count}} 項",
    "refresh": "重新整理",
    "searchPlaceholder": "按藥物、病人姓名或 MRN 搜尋...",
    "priority": {
      "all": "全部優先級",
      "stat": "STAT",
      "asap": "ASAP",
      "routine": "常規",
      "scheduled": "預定"
    },
    "loadError": "無法載入醫囑隊列",
    "retry": "重試",
    "empty": {
      "title": "已全部處理完成",
      "description": "沒有待核對的醫囑。"
    },
    "columns": {
      "patient": "病人",
      "medication": "藥物",
      "doseRouteFreq": "劑量 / 途徑 / 頻次",
      "priority": "優先級",
      "orderingProvider": "開立醫師",
      "ordered": "開立時間",
      "actions": "操作"
    },
    "row": {
      "unknown": "未知",
      "mrnLabel": "MRN：{{mrn}}",
      "mrnUnknown": "---",
      "controlled": "管制藥 {{schedule}}",
      "providerFallback": "醫師 #{{id}}",
      "providerUnknown": "---"
    },
    "actions": {
      "verify": "核對",
      "verifyTooltip": "核對此醫囑",
      "reject": "拒絕",
      "rejectTooltip": "拒絕並停用",
      "confirmReject": "確認",
      "cancelReject": "取消",
      "rejectReasonPlaceholder": "拒絕原因..."
    },
    "toast": {
      "verifySuccess": "醫囑 #{{id}} 已核對",
      "verifyError": "核對醫囑失敗",
      "rejectSuccess": "醫囑 #{{id}} 已拒絕並停用",
      "rejectError": "拒絕醫囑失敗",
      "rejectReasonRequired": "請填寫拒絕原因",
      "notIndependent": "開立醫囑者不能核對自己的醫囑。",
      "overrideSuccess": "醫囑 {{id}} 已喺未經藥劑師核對嘅情況下生效",
      "overrideError": "無法記錄越權",
      "overrideReasonRequired": "越權需同時填寫原因代碼同理由"
    },
    "verifyDialog": {
      "title": "核對用藥醫囑",
      "instruction": "請確認已完成的每一項檢查。四項均為必填——部分覆核不構成核對。",
      "checks": {
        "allergy": "我已對照病人過敏史覆核此醫囑",
        "interaction": "我已覆核藥物相互作用",
        "duplicateTherapy": "我已覆核重複用藥",
        "doseRange": "我已覆核該病人的劑量"
      },
      "cancel": "取消",
      "confirm": "核對醫囑"
    },
    "override": {
      "action": "越權放行",
      "confirm": "記錄越權",
      "cancel": "取消",
      "tooltip": "喺未經藥劑師核對嘅情況下繼續。會記錄原因；唔滿足高警訊藥物嘅藥房核查。",
      "codeLabel": "越權原因代碼",
      "codePlaceholder": "請選擇原因…",
      "justificationLabel": "越權理由",
      "justificationPlaceholder": "點解喺未經藥房覆核嘅情況下繼續？",
      "code": {
        "pharmacyClosed": "藥房已關閉",
        "urgentClinicalNeed": "緊急臨床需要",
        "pharmacyUnreachable": "無法聯絡藥房"
      }
    },
    "clarify": {
      "action": "釐清",
      "tooltip": "藥房對呢張醫囑嘅編碼同原處方唔同。要先處理先可以俾藥。",
      "heading": "藥房編碼同原處方唔同",
      "holding": "（暫停呢張醫囑）",
      "upheld": "維持原醫囑",
      "upheldTooltip": "原醫囑正確，照原樣配藥。",
      "amended": "我已修改",
      "amendedTooltip": "記錄呢張醫囑已被修改。",
      "adopt": "採納藥房版本",
      "adoptTooltip": "根據協作執業協議或藥事委員會方案接受編碼版本。",
      "close": "關閉",
      "toast": {
        "resolved": "釐清已處理；醫囑返回待核對",
        "error": "無法處理呢個釐清"
      }
    }
  },
  "reconciliation": {
    "title": "用藥核對",
    "subtitle": "{{patient}} | {{mrn}} | 診症 #{{encounter}}",
    "complete": "完成核對",
    "loading": "正在載入用藥...",
    "column": {
      "home": "家居用藥",
      "inpatient": "住院用藥",
      "discharge": "出院用藥"
    },
    "emptyHome": "未找到家居用藥。",
    "emptyInpatient": "未找到住院用藥。",
    "emptyDischarge": "尚無出院用藥。請在其他欄選擇繼續或修改用藥。",
    "changedFromHome": "與家居用藥相比已變更",
    "action": {
      "continue": "繼續",
      "modify": "修改",
      "discontinue": "停用",
      "discontinueShort": "D/C",
      "newOrder": "新增"
    },
    "addToDischarge": "加入出院用藥",
    "remove": "移除",
    "modifyForm": {
      "title": "修改用藥",
      "dose": "劑量",
      "route": "給藥途徑",
      "frequency": "頻次",
      "dosePlaceholder": "例如：500mg",
      "routePlaceholder": "例如：PO",
      "frequencyPlaceholder": "例如：BID",
      "cancel": "取消",
      "save": "儲存"
    },
    "back": "返回",
    "toast": {
      "completed": "用藥核對已完成",
      "completeError": "完成核對失敗",
      "atLeastOne": "請至少核對一項用藥後再完成"
    }
  },
  "components": {
    "dosingCalculator": {
      "title": "劑量計算器",
      "weightLabel": "病人體重 (kg) *",
      "heightLabel": "身高 (cm)",
      "gfrLabel": "GFR/CrCl (mL/min)",
      "weightPlaceholder": "例如 70",
      "heightPlaceholder": "例如 170",
      "gfrPlaceholder": "選填",
      "bsaLabel": "計算的體表面積 (Mosteller):",
      "calculate": "計算劑量",
      "error": "無法計算劑量。後端可能沒有此藥物的劑量資料。",
      "renalAdjustment": "腎功能調整:",
      "originalDose": "原本劑量:",
      "min": "最小:",
      "max": "最大:",
      "recommended": "建議: {{dose}} {{unit}}",
      "apply": "套用劑量",
      "method": {
        "weightBased": "依體重",
        "bsaBased": "依體表面積",
        "flat": "固定劑量",
        "renalAdjusted": "腎功能調整"
      },
      "unavailable": "Dosing data unavailable for {{name}} — this order isn't linked to a medication catalog entry.",
      "__review_unavailable": "EN placeholder — needs translation"
    }
  },
  "prescribe": {
    "title": "處方藥物",
    "submit": "開立處方",
    "navButton": "開處方",
    "noActiveEncounter": "處方必須連結至有效就診。請先為此病人開立或收治就診，然後再開立處方。",
    "fields": {
      "medication": "藥物",
      "dose": "劑量",
      "doseUnit": "單位",
      "route": "給藥途徑",
      "frequency": "頻次",
      "frequencyDescription": "頻次說明",
      "duration": "療程",
      "durationUnit": "療程單位",
      "totalDoses": "總劑次",
      "isPrn": "需要時（PRN）",
      "prnIndication": "需要時指徵",
      "administrationInstructions": "給藥說明",
      "patientInstructions": "病人須知",
      "quantityDispensed": "配藥數量",
      "refillsAuthorized": "可續配次數",
      "allowSubstitution": "允許仿製藥替代",
      "pharmacyNotes": "藥房備註",
      "indication": "指徵",
      "clinicalIndication": "臨床指徵",
      "priority": "優先次序"
    },
    "sections": {
      "drug": "藥物",
      "dosing": "劑量",
      "durationPrn": "療程與需要時（PRN）",
      "instructions": "用藥說明",
      "dispensing": "配藥",
      "clinical": "臨床"
    },
    "doseUnitPlaceholder": "如 mg",
    "drugSearch": {
      "placeholder": "搜尋藥物名冊…",
      "noResults": "沒有相符的名冊藥物",
      "clear": "清除選擇",
      "catalogRequired": "請從藥物名冊中選擇要處方的藥物",
      "catalogOnly": "只可處方名冊內藥物，以確保各項安全檢查均可執行。",
      "controlledBadge": "受管制藥物 — 第 {{schedule}} 級",
      "controlledTag": "受管制",
      "highAlertBadge": "高警訊藥品",
      "highAlertTag": "高警訊",
      "contraindications": "禁忌症：{{text}}"
    },
    "route": {
      "oral": "口服（PO）",
      "iv": "靜脈注射（IV）",
      "subcutaneous": "皮下注射（SC）",
      "intramuscular": "肌肉注射（IM）",
      "topical": "外用",
      "inhalation": "吸入",
      "rectal": "直腸給藥（PR）",
      "ophthalmic": "眼用",
      "transdermal": "透皮"
    },
    "frequency": {
      "QD": "每日一次（QD）",
      "BID": "每日兩次（BID）",
      "TID": "每日三次（TID）",
      "QID": "每日四次（QID）",
      "Q4H": "每4小時一次（Q4H）",
      "Q6H": "每6小時一次（Q6H）",
      "Q8H": "每8小時一次（Q8H）",
      "Q12H": "每12小時一次（Q12H）",
      "QHS": "睡前（QHS）",
      "PRN": "需要時（PRN）",
      "STAT": "即時（STAT）"
    },
    "durationUnit": {
      "days": "日",
      "weeks": "週",
      "months": "月",
      "doses": "劑次"
    },
    "priority": {
      "routine": "常規",
      "asap": "盡快",
      "stat": "即時"
    },
    "validation": {
      "prnIndicationRequired": "需要時醫囑必須填寫需要時指徵"
    },
    "contextBar": {
      "ariaLabel": "開方參考資訊",
      "allergies": {
        "label": "過敏史",
        "none": "無已知過敏",
        "severe": "嚴重"
      },
      "weight": {
        "label": "體重",
        "value": "{{weight}} kg",
        "valueWithHeight": "{{weight}} kg · {{height}} cm",
        "notRecorded": "未記錄"
      },
      "renal": {
        "label": "腎功能",
        "value": "eGFR {{egfr}} {{unit}}（{{source}}）",
        "unknown": "腎功能未知",
        "source": {
          "reported": "報告值",
          "computed": "計算值",
          "unknown": "未知"
        }
      },
      "pregnancy": {
        "label": "Pregnancy",
        "notRecorded": "Not recorded",
        "recordedOn": "recorded {{date}}",
        "outOfDate": "out of date",
        "lactating": "Lactating"
      }
    },
    "toast": {
      "success": "藥物已處方",
      "error": "無法開立此醫囑，請重試。",
      "recordStatusError": "Could not record the pregnancy status"
    },
    "cdsWarnings": {
      "heading": "已處方，附帶安全提示",
      "continue": "繼續"
    },
    "safetyReview": {
      "title": "需要安全審查",
      "proceed": "覆蓋並開具",
      "cancel": "取消",
      "reasonPrompt": "選擇覆蓋理由…",
      "freeTextLabel": "補充說明",
      "freeTextPlaceholder": "加入臨床背景（可選）",
      "hardBlockNote": "此攔截無法覆蓋。",
      "cannotOverride": "此處方無法繼續——一個或多個攔截無法覆蓋。",
      "blockKind": {
        "cds_contraindication": "禁忌",
        "cds_unavailable": "安全篩查不可用",
        "renal_contraindication": "腎功能禁忌",
        "dose_range": "劑量超出建議範圍",
        "pregnancy_contraindication": "妊娠風險",
        "unknown": "其他安全攔截"
      },
      "reasonCodes": {
        "HISTORY_REVIEWED_MANUALLY": "已手動審查病史",
        "NO_KNOWN_RISK_THIS_PATIENT": "該患者無已知風險",
        "URGENT_CLINICAL_NEED": "緊急臨床需要",
        "OTHER": "其他（請說明）",
        "BENEFIT_OUTWEIGHS_RISK": "獲益大於風險",
        "DOSE_REDUCED_PER_PROTOCOL": "已按方案減量",
        "EGFR_NOT_REPRESENTATIVE": "eGFR不具代表性",
        "SPECIALIST_ADVICE": "專科意見",
        "PATIENT_TOLERANT": "患者可耐受此劑量",
        "SPECIALIST_PROTOCOL": "遵循專科方案",
        "TITRATING_TO_EFFECT": "根據療效滴定",
        "RANGE_NOT_APPLICABLE": "範圍不適用",
        "STATUS_CONFIRMED_NEGATIVE": "已確認未懷孕",
        "BENEFIT_OUTWEIGHS_FETAL_RISK": "益處大於胎兒風險",
        "CONTRACEPTION_CONFIRMED": "已確認有效避孕",
        "PREGNANCY_BEING_TERMINATED": "正在終止妊娠"
      },
      "recordStatus": {
        "heading": "Record the patient's pregnancy status",
        "prompt": "Answering clears this block. Overriding does not answer it.",
        "notPregnant": "Not pregnant",
        "pregnant": "Pregnant",
        "notApplicable": "Not applicable",
        "button": "Record and continue"
      }
    }
  }
}
